import type React from "react";
import {memo, useMemo} from "react";

import SelectGeneric from "../SelectGeneric";

type Props = {
    minutes?: number;
    isDisabled?: boolean;
    className?: string;
    onChange: (value: number) => void;
};

const SelectAMPM: React.FC<Props> = ({className, isDisabled, minutes, onChange}) => {
    const options = useMemo(() => {
        return [
            {label: "AM", value: 0},
            {label: "PM", value: 12}
        ];
    }, []);

    // Convert minutes to AM/PM
    const selectedAMPMValue =
        minutes !== undefined && minutes >= 0
            ? Math.floor(minutes / 60) >= 12
                ? 12
                : 0
            : undefined;

    return (
        <SelectGeneric
            className={className}
            isDisabled={isDisabled}
            isSearchable={false}
            options={options}
            placeholder="AM/PM"
            testID="select-ampm"
            value={selectedAMPMValue}
            onChange={onChange}
        />
    );
};

export default memo(SelectAMPM);
